$(document).ready(function () {
    $(document).on('click', '[data-cart-page-rack-delete], [data-ajax-cart-rack-delete]', function (e) {
        e.preventDefault();

        var lineID = $(this).data('line-item-key'),
            handles = $(this).data('cart-page-rack-handles').split('|').filter(Boolean),
            rackQty = Number($(this).data('cart-page-item-qty')),
            keepQty = $(this).data('cart-page-keep-qty') || 0
        if (Shopify.theme.jsCart) {
            var $cartItem = Shopify.theme.jsCart.$section.find("[data-line-item=\"".concat(lineID, "\"]"));
            $cartItem.css('opacity', '0.5');
        }

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + keepQty + '&line=' + lineID,
            dataType: 'json',
            success: function success(cart) {
                try {
                    if (Shopify.theme.jsCart) {
                        $cartItem.addClass('animated zoomOut');
                        $cartItem.remove();
                    }
                    var removeHandle = function (cart) {
                        if (handles.length) {
                            var handle = handles.shift(),
                                itemData = handle.split(':'),
                                item = cart.items.find(function (item) {
                                    return item.handle === itemData[0]
                                });
                            if (item) {
                                var qty = Math.max(item.quantity - itemData[1], 0);
                                $.ajax({
                                    type: 'POST',
                                    url: '/cart/change.js',
                                    data: 'quantity=' + qty + '&id=' + item.id,
                                    dataType: 'json',
                                    success: function success(cart) {
                                        removeHandle(cart);
                                    },
                                    error: function error(XMLHttpRequest, textStatus) {
                                        var response = eval('(' + XMLHttpRequest.responseText + ')');
                                        response = response.description;
                                    }
                                });
                            } else {
                                removeHandle(cart);
                            }
                        } else {
                            if (Shopify.theme.jsCart) {
                                Shopify.theme.jsCart.updateView(cart, lineID);
                            }

                            if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
                                Shopify.theme.jsAjaxCart.updateView();
                            }
                        }
                    }
                    removeHandle(cart);
                } catch (e) {
                    console.log(e);
                }
            },
            error: function error(XMLHttpRequest, textStatus) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
            }
        });

        return false;
    });
});
